export default function truncateText(text = '', by: number) {
	if (text.length > by) {
		return text.substring(0, by) + '...';
	}

	return text;
}
